module.exports = __webpack_public_path__ + "static/media/tip-six.c9226f4a.png";